import { render, staticRenderFns } from "./printLogisticsRecList.vue?vue&type=template&id=36230ddd&scoped=true&"
import script from "./printLogisticsRecList.vue?vue&type=script&lang=js&"
export * from "./printLogisticsRecList.vue?vue&type=script&lang=js&"
import style0 from "./printLogisticsRecList.vue?vue&type=style&index=0&id=36230ddd&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36230ddd",
  null
  
)

component.options.__file = "printLogisticsRecList.vue"
export default component.exports